import axios from "axios";
import { i18n } from "../i18n/i18n.js";

const state = {
    token: localStorage.getItem ("token"),
    cid: localStorage.getItem ("company"),
    user: {
        username:    localStorage.getItem ("username"),
        company:     parseInt (localStorage.getItem ("company") || "0"),
        id:          parseInt (localStorage.getItem ("uid")     || "0"),
        lines:       JSON.parse (localStorage.getItem ("lines")),
        groups:      new Set (JSON.parse (localStorage.getItem ("groups"))),
    },
    loginpossible: false,
    testloginpossible: false,
    loginpossibletext: "",
    loginActive: false,
    tokenCreationTime: null,
    registerActive: false,
    contactList : [],
};

const mutations = {
    SET_TOKEN(state, {token, creationTime}) {
        state.token = token
        if (creationTime) {
            state.tokenCreationTime = new Date (creationTime)
        } else {
            state.creationTime = new Date ()
        }
        if (token) localStorage.setItem ("token", token)
        else       localStorage.removeItem ("token")
        //console.log ("SET-TOKEN", state.token)
    },
    UPDATE_LOADING(state, payload) {
        state.loading = payload
    },
    SET_USERNAME(state, username) {
        state.user.username = username
        if (username) localStorage.setItem ("username",  username)
        else          localStorage.removeItem ("username")
    },
    SET_COMPANY(state, cid) {
        state.cid = cid
        //console.log ("SET_COMPANY", cid)
        if (cid) localStorage.setItem ("company", cid)
        else     localStorage.removeItem ("company")
    },
    SET_UID(state, uid) {
        state.user.id = uid;
        if (uid) localStorage.setItem ("uid", uid)
        else     localStorage.removeItem ("uid")
    },
    SET_LOGINPOSSIBLE(state, payload) {
        state.loginpossible = payload;
    },
    SET_TESTLOGINPOSSIBLE(state, payload) {
        state.testloginpossible = payload;
    },
    SET_LOGINPOSSIBLE_TEXT(state, payload) {
        state.loginpossibletext = payload;
    },
    SET_LOGIN_ACTIVE(state, active) {
        state.loginActive = active
    },
    SET_LINES(state, lines) {
        state.user.lines = lines
        if (lines) localStorage.setItem    ("lines", JSON.stringify (lines))
        else       localStorage.removeItem ("lines")
    },
    SET_GROUPS(state, groups) {
        state.user.groups = groups
        localStorage.setItem    ("groups", JSON.stringify (groups))
    },
    SET_REGISTER_ACTIVE(state, newState) {
        state.registerActive = newState
    },
    SET_CONTACT_LIST(state, contactList) {
        state.contactList = contactList
    },
    DELETE_FROM_CONTACT_LIST(state, id) {
        state.contactList = state.contactList.filter (c => c.id != id)
    }
};

const actions = {
    setToken({ commit }, {token, creationTime}) {
        commit("SET_TOKEN", {token, creationTime});
    },
    /* eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }] */
    loginPossible({ commit }, _data) {
        let token = localStorage.getItem ("token")
        if (document.cookie.indexOf ("sessionid=") == -1) {
            commit  ("UPDATE_LOADING",  true)
            commit  ("SET_TOKEN",       {token: null})
            commit  ("SET_USERNAME",    null)
            commit  ("SET_UID",         null)
            commit  ("SET_COMPANY",     null)
            token = ""
        }
        return axios
            .get("/vue/maintenance/", {
                headers: {Authorization: "Token " + token},
                withCredentials: true
            })
            .then (response => {
                const rdata = response.data.data
                let new_token = rdata.jwt
                if (token != new_token) {
                    commit ("SET_TOKEN", {token: new_token, creationTime: rdata.sent_created})
                }
                commit("SET_LOGINPOSSIBLE",      rdata.login_allowed)
                commit("SET_TESTLOGINPOSSIBLE",  rdata.test_login_allowed)
                commit("SET_LOGINPOSSIBLE_TEXT", rdata.flash_text)
                localStorage.setItem ("subdomain", rdata.subdomain)
                if (rdata.shop_url) {
                    window.location.href = rdata.shop_url
                }
            });
    },
    register({commit}, data) {
        commit ("SET_REGISTER_ACTIVE", true)
        return axios
            .post("/vue/register/contact/", data.user, {withCredentials: true})
            .then(response => {
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    commit ("SET_REGISTER_ACTIVE", false)
                    data.self.$toastr ("error", messages, i18n.t("error"))
                } else {
                    data.self.$buefy.snackbar.open ({
                        type: "is-success",
                        position: "is-top",
                        indefinite: true,
                        actionText: null,
                        message: data.self.$t ("register-contact-success")
                    })
                }
            })
            .catch(function(err) {
                data.self.$toastr("error", err.message, i18n.t("error"));
                commit ("SET_REGISTER_ACTIVE", false)
            });
    },
    registerCompany({commit}, data) {
        commit ("SET_REGISTER_ACTIVE", true)
        return axios
            .post("/vue/register/company/", data.user, {withCredentials: true})
            .then(response => {
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    commit ("SET_REGISTER_ACTIVE", false)
                    return data.self.$toastr("error", messages, i18n.t("error"));
                } else {
                    data.self.$router.push({ name: "home" });
                    data.self.$buefy.snackbar.open ({
                        type: "is-success",
                        position: "is-top",
                        indefinite: true,
                        actionText: null,
                        message: data.self.$t ("register-company-success")
                    })
                }
            })
            .catch(function(err) {
                commit ("SET_REGISTER_ACTIVE", false)
                data.self.$toastr("error", err.message, i18n.t("error"));
            });
    },
    forgotPassword(_, data) {
        return axios
            .post("/vue/password/reset/", data.user, {withCredentials: true})
            .then(response => {
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    return data.self.$toastr("error", messages, i18n.t("error"));
                } else {
                    data.self.$router.push({ name: "login" });
                    data.self.$toastr("success", i18n.t("reset-link"), i18n.t("success"));
                }
            })
            .catch(function(err) {
                data.self.$toastr("error", err.message, i18n.t("error"));
            });
    },
    resetPassword(_, data) {
        return axios
            .post("/vue/password/change/", data.user, {withCredentials: true})
            .then(response => {
                if (!response.data.status) {
                    let messages = response.data.messages.join ("<br>")
                    return data.self.$toastr("error", messages, i18n.t("error"));
                } else {
                    data.self.$router.push({ name: "home" });
                    data.self.$toastr(
                        "success",
                        i18n.t("password-changed"),
                        i18n.t("success")
                    );
                }
            })
            .catch(function(err) {
                data.self.$toastr("error", err.message, i18n.t("error"));
            });
    },
    login({ commit, state }, data) {
        return axios
            .post ("/vue/login/", data.user, {withCredentials: true})
            .then (response => {
                if (!response.data.status) {
                    var messages = response.data.messages.join ("<br />")
                    return data.self.$toastr("error", messages, i18n.t("error"))
                } else {
                    let rdata       = response.data.data
                    let cid         = rdata.user.company [0]
                    commit ("SET_TOKEN",       {token: rdata.jwt})
                    commit ("SET_USERNAME",    rdata.user.username)
                    commit ("SET_UID",         rdata.user.id)
                    commit ("SET_COMPANY",     cid)
                    commit ("SET_LOGIN_ACTIVE", false)
                    commit ("SET_LINES",        {lines: rdata.user.lines, active: rdata.user.last_line})
                    commit ("SET_GROUPS",       new Set (rdata.user.groups))
                    if (!data.self.$route.query.redirect) {
                        if (state.user.groups.has ("IS_DEALER_ADMIN")) {
                            data.self.$router.push ({name: "companies", params: { cid: cid}})
                        } else {
                            if (rdata.user.lines.length > 1) {
                                data.self.$router.push ({ name: "select-line"})
                            } else {
                                commit ("SET_LOGIN_ACTIVE", true)
                                window.location.href = rdata.user.shop_url
                            }
                        }
                    } else {
                        data.self.$router.push(data.self.$route.query.redirect)
                    }
                    data.self.$toastr("success", i18n.t("logged-in"), i18n.t("success"))
                }
            })
            .catch (function (err) {
                data.self.$toastr("error", err.message, i18n.t("error"))
            })
    },
    redirect2Shop ({getters}) {
        return axios
            .get (
                "/vue/shop-url/",
                { headers: { Authorization: "Token " + getters.getUserToken }})
            .then ( response => {
                window.location.href =  response.data.data.login_url
            })
    },
    logout({ commit }, _) {
        return new Promise(resolve => {
            commit  ("UPDATE_LOADING",  true)
            commit  ("SET_TOKEN",       {token: null})
            commit  ("SET_USERNAME",    null)
            commit  ("SET_UID",         null)
            commit  ("SET_COMPANY",     null)
            resolve ()
        });
    },
    fetchContactList ({ commit }, {self, active}) {
        const token = localStorage.getItem ("token")
        axios.get ("/vue/contact/list/",
            { params: {active: active  ? "1": "0"},
              headers: {Authorization: "Token " + token},
              withCredentials: true
            }
        ).then (response => {
            if (!response.data.status) {
                const messages = response.data.messages.join ("<br />")
                return self.$toastr("error", messages, i18n.t("error"))
            } else {
                const rdata       = response.data.data
                commit ("SET_CONTACT_LIST", rdata.users)
            }
        })
    },
    deleteContact ({commit}, {self, cid}) {
        const token = localStorage.getItem ("token")
        axios.delete (`/vue/contact/${cid}/delete/`,
            { headers: {Authorization: "Token " + token}, withCredentials: true}
        ).then (response => {
            if (!response.data.status) {
                const messages = response.data.messages.join ("<br />")
                return self.$toastr("error", messages, i18n.t("error"))
            } else {
                commit ("DELETE_FROM_CONTACT_LIST", cid)
                return self.$toastr("success", "deleted", i18n.t("success"))
            }
        })
    },
};

const getters = {
    isDealerAdmin (state) {
        return state.user.groups.has ("IS_DEALER_ADMIN")
    },
    canCreateCompanies (state) {
        return state.user.groups.has ("	CAN_CREATE_COMPANIES")
    },
    getUserToken (state) {
        //console.log ("GET-TOKEN", localStorage.getItem("token")) // state.token
        return state.token // localStorage.getItem("token")
    },
    getUserTokenReactive: state => state.token,
    getUserUsername () {
        return state.user.username // localStorage.getItem("username")
    },
    getUserTokenState (state) {
        //console.log ("GET-TOKEN-STATE", state.token)
        return state.token
    },
    getUser:                    state => state.user,
    //getLoginPossible:           state => state.loginpossible,
    getLoginPossible (state) {
        return state.loginpossible
    },
    getTestLoginPossible:       state => state.testloginpossible,
    getLoginPossibleText:       state => state.loginpossibletext,
    getCompany (state) {
        //console.info ("getCompany", state.cid)
        return state.cid
    },
    getLoginActive:      state => state.loginActive,
    getRegisterActive:   state => state.registerActive,
    contactList:         state => state.contactList
};

const user = {
  state,
  mutations,
  actions,
  getters
};

export default user;
